export const styles = {
  page: {
    padding: '20px 42px',
    width: 1100,
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: 'black',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    marginTop: 8,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: 16,
  },
  pageContent: {
    borderRadius: '16px',
    boxShadow: '0px 2px 10px 0px rgba(39, 55, 84, 0.08)',
    display: 'flex',
    padding: '16px 32px',
    flexDirection: 'column',
    marginTop: 20,
    background: 'white',
  },
  contentTitleMain: {
    fontFamily: 'Proxima Nova, sans-serif',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '22px',
    color: '#1A2547',
  },
  contentTitle: {
    fontFamily: 'Proxima Nova, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '22px',
    color: '#1A2547',
  },
  contentDescription: {
    color: '#505050',
    fontFamily: 'Proxima Nova, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '21px',
    letterSpacing: '-0.154px',
  },
  warningBox: {
    background: '#FFF3CD',
    borderRadius: 4,
    color: 'black',
    fontFamily: 'Proxima Nova, sans-serif',
    padding: '4px 8px',
    width: 'fit-content',
  },
  centeredContent: {
    display: 'flex',
    justifyContent: 'center',
  },
}
